import React, { useContext } from 'react';
import {
  Alert, Button, DrawerBody, DrawerFooter, Link, Typography
} from '@one-thd/sui-atomic-components';
import proptypes from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { AddToCoreContext } from '../../core/AddToCoreContext';
import { AiPromptSuccessSection } from '../../common/ai-list-builder/AiPromptSuccessSection';

const { string, func, shape, arrayOf } = proptypes;

const AddToListSuccess = ({
  newListDetails,
  onClose,
  products = []
}) => {
  const { selectedListId, selectedListName } = useContext(AddToCoreContext);

  const listName = selectedListName || newListDetails.listName;
  const listId = selectedListId || newListDetails.listId;

  // Determine the correct count for pluralization
  const itemCount = products.length;
  const itemText = itemCount > 1 ? 'items have' : 'item has';

  return (
    <>
      <DrawerBody>
        <Alert status="success" size="large">
          <Typography>
            Your {itemText} been added to your list:&nbsp;
            <Link title={listName} href={`/list/view/details/${listId}`} weight="bold">
              {listName}
            </Link>
          </Typography>
        </Alert>

        <AiPromptSuccessSection
          addType="list"
          entityId={listId}
          entityIdField="listId"
          redirectUrl={`/list/view/details/${listId}`}
          title="Complete your list with AI"
          description={(
            'Describe your project or paste a list of materials. '
            + 'We\'ll use your input to add all the items you might need to your list!'
          )}
        />
      </DrawerBody>
      <DrawerFooter>
        <Button
          fullWidth
          variant="secondary"
          onClick={() => { onClose('ok', { isUserInitiated: true }); }}
        >
          Close
        </Button>
      </DrawerFooter>
    </>
  );
};

AddToListSuccess.propTypes = {
  newListDetails: shape({
    listId: string,
    listName: string
  }).isRequired,
  onClose: func.isRequired,
  products: arrayOf(shape({
    itemId: string,
    quantity: string
  }))
};

AddToListSuccess.defaultProps = {
  products: []
};

AddToListSuccess.displayName = 'AddToListSuccess';

AddToListSuccess.dataModel = extend(AiPromptSuccessSection.dataModel);

export { AddToListSuccess };
